// extracted by mini-css-extract-plugin
export default {"container":"CardResult_container__3YolD","label":"CardResult_label__JTzQM","content":"CardResult_content__RTkE8"};